import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'certificate-list',
  name: '电子公证书',
  icon: '证',
  group: '公证组件',
  description: '展示已出具的电子公证书。',
  defaultProps: {
    title: '电子公证书',
    limit: 5
}
}
